import { httpClient } from '../../../shared/api/httpClient';
import type { TokenResponse } from '../../../shared/api/contracts/styleTransferSchemas';
import { adaptUserLoginResponse, adaptUserRegisterResponse } from '../../../shared/api/intelliSightAdapters';
import { buildPolicyAcceptancePayload } from '../../../shared/config/policyMetadata';
import { recordPolicyAcceptance, resolvePolicyLocale } from '../../../shared/config/policyAcceptanceStorage';
import { collectDeviceFingerprint } from '../../../shared/device/collectDeviceFingerprint';

export interface EmailAuthPayload {
  email: string;
  password: string;
}

export interface EmailRegisterPayload {
  email: string;
  password: string;
  username?: string;
  displayName?: string;
  referralCode?: string;
}

export interface PasswordResetPayload {
  email: string;
}

const REGISTER_ENDPOINT = '/api/v1/users/register';
const LOGIN_ENDPOINT = '/api/v1/users/login';
const PASSWORD_RESET_ENDPOINT = '/api/v1/users/forgot-password';

export async function registerWithEmail(payload: EmailRegisterPayload): Promise<TokenResponse> {
  const policyAcceptance = buildPolicyAcceptancePayload(resolvePolicyLocale());
  const deviceFingerprint = collectDeviceFingerprint();
  const referralCode = payload.referralCode?.trim().toUpperCase() || undefined;
  const response = await httpClient.post(REGISTER_ENDPOINT, {
    json: {
      email: payload.email,
      password: payload.password,
      registrationSource: 'studio',
      username: payload.username ?? payload.displayName ?? payload.email.split('@')[0],
      displayName: payload.displayName ?? payload.username,
      referralCode,
      deviceFingerprint,
      policyAcceptance
    }
  });
  const tokenResponse = adaptUserRegisterResponse(response);
  recordPolicyAcceptance(policyAcceptance);
  return tokenResponse;
}

export async function loginWithEmail(payload: EmailAuthPayload): Promise<TokenResponse> {
  const response = await httpClient.post(LOGIN_ENDPOINT, {
    json: payload
  });
  return adaptUserLoginResponse(response);
}

export async function requestPasswordReset(payload: PasswordResetPayload): Promise<void> {
  await httpClient.post(PASSWORD_RESET_ENDPOINT, {
    json: payload
  });
}
